import Vue from 'vue'
import Vuex from 'vuex'
import Auth from './modules/Auth'
import M0001User from '@/components/functions/M0001User/M0001UserStore'
import PageManagement from '@/components/functions/PageManagement/PageManagementStore'
import Client from '@/components/functions/CLient/ClientStore'
import Project from '@/components/functions/Project/ProjectStore'
import Product from '@/components/functions/Product/ProductStore'
import ProductionProcedure from '@/components/functions/ProductionProcedure/ProductionProcedureStore'
import Frame from '@/components/functions/Frame/FrameStore'
import FrameType from '@/components/functions/FrameType/FrameTypeStore'
import ChangePassword from '@/components/functions/ChangePassword/ChangePasswordStore'
import PoHWorkDontTouch from '@/components/functions/PoHWorkDontTouch/Preview'
Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    Auth,
    M0001User,
    PageManagement,
    Client,
    Project,
    PoHWorkDontTouch,
    Product,
    ProductionProcedure,
    Frame,
    FrameType,
    ChangePassword
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js